import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { usePatient } from "@louise/patients/hooks/usePatient";
import { ContraceptionProvider, getResumeRoute } from "./ContraceptionContext";
import { ContraceptionMethodsScreen } from "./screens/ContraceptionMethodsScreen";
import { ContraceptionDetailsScreen } from "./screens/ContraceptionDetailsScreen";
import { ContraceptionCompleteScreen } from "./screens/ContraceptionCompleteScreen";
import {
  MedicalHistoryLoadingScreen,
  MedicalHistoryQuestionProvider,
} from "@src/packages/medical-history/components";

export type ContraceptionStackParamList = {
  ContraceptionMethods: undefined;
  ContraceptionDetails: undefined;
  ContraceptionComplete: undefined;
};

const Stack = createNativeStackNavigator<ContraceptionStackParamList>();

function ContraceptionStack() {
  const { data: patient } = usePatient();
  const initialRoute = getResumeRoute(patient);

  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen
        name="ContraceptionMethods"
        component={ContraceptionMethodsScreen}
      />
      <Stack.Screen
        name="ContraceptionDetails"
        component={ContraceptionDetailsScreen}
      />
      <Stack.Screen
        name="ContraceptionComplete"
        component={ContraceptionCompleteScreen}
      />
    </Stack.Navigator>
  );
}

export function ContraceptionNavigator() {
  const { data: patient, isLoading } = usePatient();

  // Wait for patient data so the provider can initialise state synchronously
  if (isLoading || !patient) {
    return <MedicalHistoryLoadingScreen />;
  }

  return (
    <ContraceptionProvider>
      <MedicalHistoryQuestionProvider
        section="contraception"
        sectionLabelKey="med_history.review.section_title.contraception"
        helpTextKey="med_history.question_screen.flow_help.contraception"
      >
        <ContraceptionStack />
      </MedicalHistoryQuestionProvider>
    </ContraceptionProvider>
  );
}
